/**
* 基础菜单 商品议价管理
*/
<template>
  <div class="contianer">
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="">
        <el-date-picker
          v-model="formInline.Date"
          type="daterange"
          align="right"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="">
        <el-input size="small" v-model="formInline.product_code" placeholder="商品编码" clearable></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-input size="small" v-model="formInline.sale_name" placeholder="销售名称" clearable></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-input size="small" v-model="formInline.cust_mobile" placeholder="会员手机号" clearable></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-input size="small" v-model="formInline.real_name" placeholder="议价人" clearable></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-select v-model="formInline.status" placeholder="有效状态" clearable>
          <el-option label="有效" value="1"></el-option>
          <el-option label="无效" value="0"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" @click="search">查询</el-button>
        <el-button size="small" type="primary" @click="adddiscount" class="add-button">新增</el-button>
        <el-button size="small" type="primary" @click="editdiscount" class="edit-button">修改</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <div style="height: 530px;overflow-y: auto">
      <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
                @cell-dblclick="cellDbClick" @selection-change="handleSelectionChange"
                :header-cell-style="{background:'#F5F7FA',color:'#666666'}"
                element-loading-text="拼命加载中" style="width: 90%;">
        <el-table-column align="center" type="selection" width="60">
        </el-table-column>
        <el-table-column
          label="序号"
          width="60">
          <template slot-scope="scope">
            {{pageparm.pageSize * (pageparm.currentPage - 1) + (scope.$index + 1)}}
          </template>
        </el-table-column>
        <el-table-column prop="create_time" label="议价日期" width="200" :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column prop="product_code" label="商品编码" min-width="160" :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column prop="sale_name" label="销售名称" width="300" :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column prop="mobile" label="会员手机号" width="160" :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column prop="final_price" label="最终价格" width="135">
        </el-table-column>
        <el-table-column prop="status" label="有效状态" width="75">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.status"
              :active-value="1"
              :inactive-value="0"
              @change="changeStatus(scope.row.id,scope.row.status)"
              active-color="#409EFF">
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column prop="real_name" label="议价人" width="180">
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <el-dialog :close-on-click-modal="false" :close-on-press-escape="false"
               :title="dialogTitle"
               :visible.sync="flashDialogVisible"
               width="30%"
               :before-close="handleClose"
               center>
      <el-form label-width="155px" :model="ruleForm" :rules="rules" ref="ruleForm" class="ruleForm">
        <el-form-item label="商品销售名称" prop="sale_id" class="relative">
          <el-select v-model="ruleForm.sale_id" filterable placeholder="请选择商品销售名称" clearable
                     :filter-method="remoteMethod" class="productInterval" :popper-append-to-body="false"
                     @focus="focusProductName()" @change="handleChange" @clear="clear()">
            <el-option :title="item.sale_name"
                       v-for="item in productData"
                       :key="item.sale_id"
                       :label="item.sale_name"
                       :value="item.sale_id">
            </el-option>
            <div class="pagination-absolute">
              <el-pagination :small="small" style="height: 30px;margin-top: 8px"
                             @size-change="productHandleSizeChange"
                             @current-change="productHandleCurrentChange"
                             :current-page.sync="productCurrentPage"
                             :page-size="productPagesize"
                             layout="total, prev, pager, next"
                             :total="productTotalSize">
              </el-pagination>
            </div>
          </el-select>
        </el-form-item>
        <el-form-item label="会员账号" prop="mobile" class="relative r50">
          <el-input size="small" v-model="ruleForm.mobile" auto-complete="off" clearable maxlength="11"
                    placeholder="请输入会员账号" @blur="getcustId(ruleForm.mobile)"></el-input>
        </el-form-item>
        <el-form-item label="最终价" prop="final_price" class="relative r50">
          <el-input size="small" v-model="ruleForm.final_price" auto-complete="off" clearable maxlength="8"
                    placeholder="请输入最终价"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="saveSort('ruleForm')">{{ brandButtonText }}</el-button>
            <el-button @click="handleClose">取消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  negoUpdate,
  negoList,
  negoAdd,
  negoDisable,
  negoEnable,
  negoDetail,
  productSaleList,
  custInfo
} from '../../api/basisMG'
  import Pagination from '../../components/Pagination'
  import {timestampToDate} from "../../utils/util"

  export default {
    name: 'gift',
    data: () => {
      var validateNum = (rule, value, callback) => {
        if (value === '' || value == undefined || value == null) {
          return callback(new Error('请输入会员账号'));
        } else if (!(/(^[1-9]\d*$)/.test(value))) {
          return callback(new Error('请输入正确的手机号'));
        } else {
          custInfo(value).then(response => {
            if (response.code === 0) {
              callback(); // 验证成功
            } else {
              callback(new Error('会员号不存在或未会员认证')); // 验证失败
            }
          })
          .catch(error => {
            callback(new Error('验证手机号时出错: ' + error.message));
          })
        }
      };
      var finalPrice = (rule, value, callback) => {
        if (value === '' || value == undefined || value == null) {
          return callback(new Error('请输入最终价'));
        }
        const regex = /^(?:0|[1-9]\d*)(?:\.\d{1,2})?$/;
        if (!regex.test(value)) {
          return callback(new Error('请输入正整数或最多输入两位小数'));
        }
        // 如果通过验证，则正常回调，不传递错误
        return callback();
      };
      return {
        loading: false, //是显示加载
        flashDialogVisible: false,  // 弹窗
        dialogTitle: '',  // 标题
        selectTableData: [],
        status: true,
        small: true,
        productId: '',
        productData: [],
        brandButtonText: '',
        formInline: {
          page: 1,
          rows: 10,
          sale_name: "",
          product_code: "",
          cust_mobile: "",
          real_name: "",
          start_create_time: "",
          end_create_time: "",
          status: ""
        },
        rules: {
          sale_id: [{required: true, message: '请选择商品销售名称', trigger: 'blur'}],
          mobile: [{required: true, validator: validateNum, trigger: 'blur'}],
          final_price: [{required: true, validator: finalPrice, trigger: 'blur'}],
        },
        ruleForm: {
          id: '',
          sale_id: "",
          product_id: "",
          cust_id: "",
          mobile: "",
          final_price: ""
        },
        listData: [], //用户数据
        // 分页参数
        pageparm: {
          currentPage: 1,
          pageSize: 10,
          total: 10
        },
        sale_id: '',
        product_id: '',
        productCurrentPage: 1,
        productPagesize: 10,
        productTotalSize: 0,
        status: [{
          name: '是',
          value: 1
        }, {
          name: '否',
          value: 0
        }],
        custSaleName: '',
        selectedsaleName: '',
        cust_id: ''
      }
    },
    // 注册组件
    components: {
      Pagination
    },
    /**
     * 创建完毕
     */
    created() {
      this.getdata(this.formInline)
    },
    mounted() {

    },
    methods: {
      getcustId(mobile) {
        custInfo(mobile)
          .then(response => {
            if (response.success) {
              this.cust_id = response.content
            }
          })
      },
      // 获取公司列表
      getdata(parameter) {
        this.loading = true
        negoList(parameter)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.listData = res.content.rows
              // 分页赋值
              this.pageparm.currentPage = this.formInline.page
              this.pageparm.pageSize = this.formInline.rows
              this.pageparm.total = res.content.total
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      // 分页插件事件
      callFather(parm) {
        this.formInline.page = parm.currentPage
        this.formInline.rows = parm.pageSize
        this.getdata(this.formInline)
      },
      // 新增商品议价
      adddiscount() {
        this.flashDialogVisible = true;
        this.dialogTitle = '新增商品议价';
        this.brandButtonText = '保存'
        this.ruleForm = {
          id: '',
          sale_id: "",
          product_id: "",
          cust_id: "",
          mobile: "",
          final_price: ""
        }
        this.getProduct();
      },
      // 修改商品议价
      editdiscount() {
        if (this.selectTableData.length == 0) {
          this.$message.error('请选择一条数据再操作!');
          return
        }
        if (this.selectTableData.length > 1) {
          this.$message.error('当前操作只能选择一条数据!');
          return
        }
        this.productId = this.selectTableData[0].id;
        this.dialogTitle = '修改商品议价';
        this.brandButtonText = '确认修改'
        this.flashDialogVisible = true;
        this.selectedsaleName = this.selectTableData[0].sale_name;
        this.getProduct(this.selectTableData[0].product_code);
        negoDetail(this.selectTableData[0].id)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              if(res.content) {
                this.ruleForm.id = res.content.id;
                this.ruleForm.sale_id = res.content.sale_id;
                this.ruleForm.product_id = res.content.product_id;
                this.ruleForm.cust_id = res.content.cust_id;
                this.ruleForm.mobile = res.content.mobile;
                this.ruleForm.final_price = res.content.final_price
              }
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      // 新增商品议价
      saveSort(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.loading = true;
            if (this.dialogTitle == '新增商品议价') {
              this.ruleForm.cust_id = this.cust_id;
              negoAdd(this.ruleForm)
                .then(res => {
                  this.loading = false
                  if (res.success == false) {
                    this.$message({
                      type: 'info',
                      message: res.msg
                    })
                  } else {
                    this.$message({
                      type: 'success',
                      message: '您已成功新增商品议价信息!'
                    });
                    this.flashDialogVisible = false;
                    this.getdata(this.formInline)
                  }
                })
                .catch(err => {
                  this.loading = false
                  this.$message.error('网络错误，请稍后再试!')
                })
            } else {
              this.ruleForm.id = this.productId;
              negoUpdate(this.ruleForm)
                .then(res => {
                  this.loading = false
                  if (res.success == false) {
                    this.$message({
                      type: 'info',
                      message: res.msg
                    })
                  } else {
                    this.$message({
                      type: 'success',
                      message: '您已成功修改商品议价信息!'
                    });
                    this.flashDialogVisible = false;
                    this.getdata(this.formInline)
                  }
                })
                .catch(err => {
                  this.loading = false
                  this.$message.error('网络错误，请稍后再试！')
                })
            }
          } else {
            console.log('error submit!!');
          }
        });
      },
      // 搜索事件
      search() {
        if (this.formInline.Date) {
          this.formInline.start_create_time = timestampToDate(this.formInline.Date[0])
          this.formInline.end_create_time = timestampToDate(this.formInline.Date[1])
        } else {
          this.formInline.start_create_time = ''
          this.formInline.end_create_time = ''
        }
        this.formInline.page = 1;
        this.getdata(this.formInline)
      },
      handleRemove(file) {
        console.log(file);
      },
      handleSelectionChange(val) {
        this.selectTableData = val
      },
      handleClose() {
        this.$refs["ruleForm"].resetFields();
        this.flashDialogVisible = false;
      },
      // 商品销售名称
      getProduct(saleName) {
        let parameter = {
          page: this.productCurrentPage,
          rows: 10,
          keyword: saleName,
          sale_type: 2293,
          put_away_status: '75',
        };
        productSaleList(parameter)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              if (!res.rows.length) {
                this.selectedsaleName = ''
              }
              this.productData = res.rows;
              this.productTotalSize = res.total;
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      remoteMethod(val) {
        this.productCurrentPage = 1
        this.saleName = val;
        this.getProduct(val)
      },
      handleClick(tab, event) {
        console.log(tab, event);
      },
      handleChange(value) {
        this.productCurrentPage = 1;
        this.productData.forEach((item) => {
          if (item.sale_id == this.ruleForm.sale_id) {
            this.selectedsaleName = item.sale_name;
            this.getProduct(item.sale_name)
          }
        })
        const selectedItem = this.productData.find(item => item.sale_id === value);
        if (selectedItem) {
          this.ruleForm.product_id = selectedItem.product_id; // 保存product_id
        } else {
          this.ruleForm.product_id = null; // 如果没找到，可以设置为null或进行其他处理
        }
      },
      clear() {
        this.getProduct()
        this.productCurrentPage = 1
        this.saleName = ''
      },
      productHandleSizeChange(val) {
        //console.log(`每页 ${val} 条`);
        this.productPagesize = val;
        this.getProduct(this.saleName)
      },
      productHandleCurrentChange(val) {
        //console.log(`当前页: ${val}`);
        this.productCurrentPage = val;
        this.getProduct(this.saleName)
      },
      focusProductName() {
        if (!this.selectedsaleName) {
          this.saleName = ''
          this.getProduct('')
        }
      },
      // 有效状态
      changeStatus(id, status) {
        if (!status) {
          negoDisable(id)
            .then(res => {
              this.loading = false
              if (res.success == false) {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              } else {
                this.$message({
                  type: 'error',
                  message: '已将状态设置为无效!'
                });
                this.getdata(this.formInline)
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('网络错误，请稍后再试！')
            })
        } else {
          negoEnable(id)
            .then(res => {
              this.loading = false
              if (res.success == false) {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              } else {
                this.$message({
                  type: 'success',
                  message: '已将状态设置为有效!'
                });
                this.getdata(this.formInline)
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('网络错误，请稍后再试！')
            })
        }
      },
      //双击复制
      cellDbClick(row, column, cell, event) {
        if (row.product_code == cell.innerText || row.sale_name == cell.innerText || row.mobile == cell.innerText || row.real_name == cell.innerText) {
          if (event.type === "dblclick") {
            var save = function (e) {
              e.clipboardData.setData('text/plain', cell.innerText);
              e.preventDefault();//阻止默认行为
            }
            document.addEventListener('copy', save);
            document.execCommand("copy");
            document.removeEventListener('copy', save);
          }
          this.$message({message: '复制成功', type: 'success'})
        }
      }
    }
  }
</script>

<style scoped>
  .contianer {
    background: #fff;
    padding: 20px;
  }

  /deep/ .user-search .el-input__inner {
    height: 40px;
    line-height: 40px;
  }

  /deep/ .user-search .el-form-item {
    margin-bottom: 10px;
  }

  /deep/ .user-search .el-button--small {
    height: 40px;
  }

  /deep/ .r55 .el-input__suffix {
    right: 55px !important;
  }

  .breadcrumb {
    margin-bottom: 15px;
  }

  /deep/ .ruleForm .el-input__inner {
    height: 40px;
    line-height: 40px;
    width: 320px;
  }

  /deep/ .ruleForm .el-input {
    width: 320px;
  }

  /deep/ .ruleForm .el-input--small {
    width: 320px;
  }

  /deep/ .textarea .el-textarea__inner {
    resize: none;
  }

  /deep/ .ruleForm .el-form-item__label {
    position: relative;
    padding: 0 22px 0 0 !important;
  }

  /deep/ .ruleForm .el-select-dropdown__list {
    padding-bottom: 50px;
    min-height: 150px;
  }

  /deep/ .ruleForm .el-select-dropdown__item {
    width: 320px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .add-button {
    background: #53B03C;
    border-color: #53B03C;
  }

  .edit-button {
    background: #58B7D6;
    border-color: #58B7D6;
  }

  .pagination-absolute {
    position: absolute;
    bottom: 0;
    background: #fff;
    width: 95%;
    padding-left: 20px;
    height: 40px;
  }

  /deep/ .el-dialog--center {
    border-radius: 8px !important;
  }

  /deep/ .el-message-box__title {
    color: #409EFF !important;
  }

  /deep/ .el-dialog__title {
    color: #409EFF !important;
  }

  .error-message {
    color: #F56C6C;
    font-size: 12px;
    line-height: 1;
    padding-top: 4px;
    position: absolute;
    top: 100%;
    left: 0;
  }

</style>





// WEBPACK FOOTER //
// src/views/Marketing/goodBargaining.vue